import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { H4 } from '@finect/tabular-core/Headings';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { Image } from '@finect/tabular-icons/image';
export var EditorContainer = styled.div.withConfig({
  displayName: "EditorContainer",
  componentId: "sc-1up482i-0"
})(["position:relative;display:flex;flex-direction:column;justify-content:space-between;border-radius:", ";", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var isRemovable = _ref2.isRemovable;
  return isRemovable ? 'padding-right: 21px;' : null;
}, function (_ref3) {
  var minHeight = _ref3.minHeight;
  if (minHeight) {
    if (minHeight.apply === 'all') return "min-height: ".concat(minHeight.size, "px;");
    return maxMediaQueries[minHeight.apply](_templateObject || (_templateObject = _taggedTemplateLiteral(["min-height: ", "px;"])), minHeight.size);
  }
  return null;
}, maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref4) {
  var isEditable = _ref4.isEditable;
  return isEditable ? 'padding-top: 48px;' : null;
}));
export var Notice = styled.div.withConfig({
  displayName: "EditorContainer__Notice",
  componentId: "sc-1up482i-1"
})(["display:flex;position:absolute;z-index:1;top:-6px;bottom:-6px;left:-9px;right:-9px;align-items:center;flex-direction:column;justify-content:center;border:2px dashed ", ";border-radius:", ";background-color:rgba(255,255,255,0.95);", ";color:", ";text-align:center;pointer-events:none;svg{display:block;margin-bottom:6px;color:", ";}", "{padding-bottom:0;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.borderRadius;
}, getFont(0), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.fontL;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.secondaryColor;
}, H4);
export var DragnDrop = function DragnDrop() {
  return React.createElement(Notice, null, React.createElement(Image, {
    size: "42",
    strokeWidth: "1"
  }), React.createElement(H4, null, "Arrastra aqu\xED tus im\xE1genes"), React.createElement(Paragraph, null, "Puedes subir varias a la vez"));
};